export const LEVELS = [
  { value: 'iniciante', label: 'Iniciante', sublabel: '< 6 meses' },
  { value: 'basico', label: 'Básico', sublabel: '6–18 meses' },
  { value: 'intermediario', label: 'Intermediário', sublabel: '1–3 anos' },
  { value: 'avancado', label: 'Avançado', sublabel: '3+ anos' },
  { value: 'elite', label: 'Elite', sublabel: 'competição' },
];

export const LEVEL_HINTS = {
  iniciante: 'Menos de 6 meses consistentes; foco em técnica e adaptação.',
  basico: '6–18 meses; domina movimentos fundamentais.',
  intermediario: '1–3 anos; carga progressiva regular.',
  avancado: '3+ anos; periodização e volumes altos.',
  elite: 'Competição ou performance medida.',
};

export const INTEREST_PRESETS = [
  'Push / Pull / Legs',
  'Upper / Lower',
  'Full body',
  'Halteres',
  'Máquinas',
  'Cardio',
  'Treino < 45 min',
  'Evitar agachamento',
  'Foco em ombros',
  'Treino em casa',
];

export function appendInterestChip(currentText, chipLabel) {
  const t = String(currentText || '').trim();
  const chip = String(chipLabel || '').trim();
  if (!chip) return t;
  if (t.toLowerCase().includes(chip.toLowerCase())) return t;
  return t ? `${t} · ${chip}` : chip;
}

export function levelLabel(value) {
  return LEVELS.find((l) => l.value === value)?.label || value || '—';
}
